// extracted by mini-css-extract-plugin
export default {"infoIcon":"detalisation-tooltip_infoIcon__b5QEE"};